import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#7B83EB\" d=\"M19 12.7h7.7c.7 0 1.3.6 1.3 1.3v7c0 2.7-2.2 4.9-4.9 4.9s-4.9-2.2-4.9-4.9v-7.7c-.1-.4.3-.7.7-.7-.1.1 0 .1.1 0z\"></path><circle cx=\"24.6\" cy=\"9\" r=\"3.2\" fill=\"#7B83EB\"></circle><circle cx=\"14\" cy=\"7.5\" r=\"4.5\" fill=\"#5059C9\"></circle><path fill=\"#5059C9\" d=\"M19.7 12.7H7.6c-.7 0-1.3.6-1.3 1.3v7.7c0 4.3 3.5 7.8 7.8 7.8s7.8-3.5 7.8-7.8V14c-.1-.7-.7-1.3-1.4-1.3.1 0 0 0 0 0z\"></path><path fill=\"#FFF\" d=\"M16.7 15.3h-1.9v5.3h-1.2v-5.3h-1.9v-1.1h5z\"></path>", 5)
  ])))
}
export default { render: render }